import NsStandout from '@britishgasenergy/react-nucleus/dist/nuc-components/NsStandout';

import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import { actionUrl } from 'config/static-content';
import { METER_TYPE_ERROR_CODES } from 'config/app-config';
import { TrackedCta } from 'components/direct-sales/select-options/components/TrackedCta';

type UnmeteredCardProps = {
  errors: {
    code: typeof METER_TYPE_ERROR_CODES[keyof typeof METER_TYPE_ERROR_CODES];
    keyword: 'Gas' | 'Electricity';
  }[];
  name: string;
};

export const UnmeteredCard = ({ errors, name }: UnmeteredCardProps) => {
  const shouldShow = errors?.some(
    ({ code }) =>
      code === METER_TYPE_ERROR_CODES.MeterMeasurementClassException ||
      code === METER_TYPE_ERROR_CODES.MHHSUnmeteredSuppliesException
  );

  if (!shouldShow) {
    return null;
  }

  return (
    <NsStandout decoration="orange" data-testid="unmeteredCardTestId">
      <h3>We can&apos;t provide you with an electricity quote</h3>
      <p>
        Your electricity meter is currently unmetered, if you think this
        isn&apos;t right, please contact your current supplier to change this.
        Once this has been fixed we&apos;ll be able to give you a quote.
      </p>
      <TrackedCta name={name}>
        <NsSecondaryCta href={actionUrl.bgHome} testId="unmeteredCardCtaTestId">
          Return to home page
        </NsSecondaryCta>
      </TrackedCta>
    </NsStandout>
  );
};
